//create pass
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || '';

const sendCombined = async (data) => {
    try {
        // console.log("sendCombined sending data:", data);
        const response = await axios.post(`${apiUrl}/api/subscription/sendcombined`, data);
        // console.log(response)
        return response.data;
    } catch (error) {
        console.error(error);
        // If the request was made and the server responded with a status code
        // that falls out of the range of 2xx, error.response will be available
        if (error.response) {
            console.error('Data:', error.response.data);
            console.error('Status:', error.response.status);
            console.error('Headers:', error.response.headers);
        }
        // You may want to handle the error somehow or re-throw it to be handled higher up
        // throw error;
    }
}

// stripe
const createPaymentIntent = async (data) => {
    // Call your backend to create a payment intent and return the client secret
    const { email } = data;
    try {
        const response = await axios.post(`${apiUrl}/api/stripe/createpaymentintent`, {
            email
        });

        return response.data.clientSecret;
    } catch (error) {
        console.error("Error creating payment intent:", error);
        throw error;
    }
};

const createBillingRequest = async (data) => {
    const response = await axios.post(`${apiUrl}/api/stripe/createbillingrequest`, data);
    return response.data;
}

const paymentService = {
    createBillingRequest,
    createPaymentIntent,
    sendCombined
}

export default paymentService;
